import { createContext, useEffect } from 'react'
import { notification } from 'antd'
import { useNotificationStateSelector } from '../../redux/selectors/common'
import { dispatchNotificationState } from '../../redux/actions/common'

type GlobalNotificationContext = object

const initalState: GlobalNotificationContext = {}

const WizrNotificationContext = createContext(initalState)

const WizrNotificationProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [api, contextHolder] = notification.useNotification({
    placement: 'topRight',
    top: 24,
    duration: 3,
    rtl: false,
    stack: { threshold: 1 },
  })
  const notificationState = useNotificationStateSelector()

  const onNotificationClose = () =>
    dispatchNotificationState({
      message: null,
      description: null,
      type: null,
    })

  useEffect(() => {
    const { message, description, type } = notificationState
    if (message) {
      let callerFn
      if (type === 'success') {
        callerFn = api.success
      } else if (type === 'info') {
        callerFn = api.info
      } else if (type === 'warning') {
        callerFn = api.warning
      } else if (type === 'failed') {
        callerFn = api.error
      } else {
        callerFn = api.error
      }
      
      callerFn({
        message,
        description,
        onClose: onNotificationClose,
        duration: type === 'failed' ? 5 : 3,
      })
    }
  }, [notificationState])

  return (
    <WizrNotificationContext.Provider value={{}}>
      {contextHolder}
      {children}
    </WizrNotificationContext.Provider>
  )
}

export { WizrNotificationProvider }
